import { BASE_PATH, deleteData, fileUpload, getData, postData } from "../api/api";
import type { GuideDocument } from "../types/guide";
import type { PageResponse } from "../types/dashboard";
import type { GuideStorageUsage } from "./packageLimitsService";

const BASE = "/guide/documents";

export const guideService = {
  list: (page = 0, size = 20) =>
    getData(`${BASE}?page=${page}&size=${size}`) as Promise<PageResponse<GuideDocument>>,

  usage: () => getData(`${BASE}/usage`) as Promise<GuideStorageUsage>,

  upload: (file: File, title?: string) => {
    const form = new FormData();
    form.append("file", file);
    const url = title ? `${BASE}?title=${encodeURIComponent(title)}` : BASE;
    return fileUpload(url, form, {
      headers: { "Content-Type": "multipart/form-data" },
    }) as Promise<GuideDocument>;
  },

  remove: (id: string) => deleteData(`${BASE}/${id}`),

  reingest: (id: string) => postData(`${BASE}/${id}/reingest`, {}),

  content: (id: string) =>
    getData(`${BASE}/${id}/content`) as Promise<{ id?: string; title?: string; fileName?: string; text?: string }>,
};

export const guideDownloadUrl = (storageRef?: string) =>
  storageRef ? `${BASE_PATH.replace(/\/$/, "")}/guide/files?ref=${encodeURIComponent(storageRef)}` : "";
